import PropTypes from "prop-types";
import { Dialog } from "@mui/material";

export const REWAMP_DIALOG_WIDTHS = {
  compact: 412,
  success: 484,
  standard: 492,
  confirm: 516,
};

export function getRewampDialogPaperProps({ size = "standard", sx = {} } = {}) {
  const width =
    typeof size === "number" ? size : REWAMP_DIALOG_WIDTHS[size] ?? REWAMP_DIALOG_WIDTHS.standard;

  if (size === "compact") {
    return {
      sx: {
        width: `${width}px`,
        maxWidth: "calc(100% - 32px)",
        borderRadius: 3,
        overflow: "hidden",
        p: 0,
        ...sx,
      },
    };
  }

  return {
    sx: {
      width: `${width}px`,
      maxWidth: "calc(100% - 32px)",
      borderRadius: 4,
      border: "1.5px solid",
      borderColor: "divider",
      boxShadow: (theme) => theme.palette.layout.cardShadow,
      p: 4,
      ...sx,
    },
  };
}

export default function RewampDialogShell({
  open,
  onClose,
  size = "standard",
  paperSx,
  children,
  "aria-labelledby": ariaLabelledby,
  "aria-describedby": ariaDescribedby,
  ...dialogProps
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={ariaLabelledby}
      aria-describedby={ariaDescribedby}
      PaperProps={getRewampDialogPaperProps({ size, sx: paperSx })}
      {...dialogProps}
    >
      {children}
    </Dialog>
  );
}

RewampDialogShell.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["compact", "success", "standard", "confirm"]),
    PropTypes.number,
  ]),
  paperSx: PropTypes.object,
  children: PropTypes.node,
  "aria-labelledby": PropTypes.string,
  "aria-describedby": PropTypes.string,
};
